import BehaviorConfig from '@/models/app-config/behavior/behavior'
import Vue, { VueConstructor } from 'vue'
import SignupDefaultAttention from './components/default/DefaultAttention.vue'
import SignUpDefaultNote from './components/default/DefaultNote.vue'
import DefaultPromoteSignup from './components/default/DefaultPromoteSignup.vue'

export interface SignUpFormParts {
  readonly note: VueConstructor
  readonly attention: VueConstructor
  readonly promoteSignup: VueConstructor
}
type SignUpFormPartsGenerator = (behavior: BehaviorConfig) => SignUpFormParts

type DefaultFormPartsGenerator = (diff?: Partial<SignUpFormParts>) => SignUpFormPartsGenerator
const empty = Vue.extend({ template: '<div></div>' })

export const defaultFormParts: DefaultFormPartsGenerator = (diff = {}) => behavior => ({
  note: SignUpDefaultNote,
  attention: defaultAttentionWith(behavior.groupLabel),
  promoteSignup: DefaultPromoteSignup,
  ...diff,
})
const defaultAttentionWith = (hostName: string) => Vue.extend({
  components: { SignupDefaultAttention },
  template: `<signup-default-attention host-name="${hostName}" />`,
})

export const mycolorFormParts = defaultFormParts()

export const vilbFormParts = defaultFormParts({
  attention: defaultAttentionWith('美ラボ'),
})

export const fitowaFormParts = defaultFormParts({
  attention: defaultAttentionWith('FITOWA'),
})

export const ledianFormParts = defaultFormParts({
  promoteSignup: empty,
})

export const loadingFormParts: SignUpFormParts = {
  note: empty,
  attention: empty,
  promoteSignup: empty,
}
